<template>
  <div class="tw-mx-auto tw-w-full tw-text-center tw-font-semibold tw-text-xl tw-py-8">
    {{ t("platform.headline_otp") }}
  </div>
  <div class="tw-flex tw-flex-row tw-flex-wrap tw-justify-center tw-items-center">
    <QRCodeDisplayer />
    <div class="tw-w-full md:tw-w-1/2 tw-p-8">
      <ol class="tw-list-decimal tw-list-inside tw-space-y-4 tw-leading-relaxed tw-pl-2">
        <li
          class="tw-font-normal [&::marker]:tw-font-bold"
          v-html="t('remote_control.otp_setup.1')"></li>
        <li
          class="tw-font-normal [&::marker]:tw-font-bold"
          v-html="t('remote_control.otp_setup.2')"></li>
      </ol>
    </div>
  </div>
  <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-center tw-items-center">
    <OTPInput
      @update="(val: string) => (otp = val)"
      @submit="handleSubmit"
      :resetCounter="otpReset" />
    <BaseButton
      :text="t('reports.variable_panel_button_submit')"
      @click="handleSubmit"
      :isWaiting="isPending"
      :disabled="!otp || isPending" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BaseButton from "../../BaseButton/BaseButton.vue";
import OTPInput from "../../OTPInput/OTPInput.vue";
import QRCodeDisplayer from "./QRCodeDisplayer.vue";
import { updateTOTPStatus } from "@/utils/localStorage";
import { useTranslation } from "i18next-vue";
import { useGlobalConfigsStore } from "@/storeModules/globalConfigs/globalConfigs";
import { useUISettingsStore } from "@/storeModules/uisettings/UISettingsStore";
import { useUserConfigStore } from "@/storeModules/userConfigs";

const { t } = useTranslation();
const { connector } = useGlobalConfigsStore();

const uiStore = useUISettingsStore();

const otp = ref("");
const otpReset = ref(0);
const isPending = ref(false);

const emits = defineEmits(["accept"]);
const handleSubmit = async () => {
  try {
    isPending.value = true;
    const response = await connector?.remoteControl.saveOTP(otp.value);
    if (response === "OK") {
      useUserConfigStore().userData.remoteControlTOTP = true;
      emits("accept");
      updateTOTPStatus(true);
      uiStore.setError({
        message: t("remote_control.otp_setup.success"),
        type: "success",
      });
    }
  } catch (error) {
    console.error("error", error);
    uiStore.setError({
      message: t(error as string, { defaultValue: t("remote_control.otp_setup.error") }),
      type: "error",
    });
  } finally {
    isPending.value = false;
    otp.value = "";
    otpReset.value += 1;
  }
};
</script>
